/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { ExportToolRequest } from '../types/ExportTool';
import type { ExportToolResponse } from '../types/ExportTool';

export type ExportToolsCreateRequest = ExportToolRequest;
export type ExportToolsCreateResponse = ExportToolResponse;

export type ExportToolsCreateQuery = {};

/**
 * POST /dmx-server/export_tools/
 *
 * ```yaml
 * operationId: export_tools_create
 * tags:
 *   - export_tools
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ExportTool'
 *     description: ''
 * ```
 */
export const exportToolsCreateOperation = (rest?: ExportToolsCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/export_tools/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/export_tools/' };
  };

/**
 * POST /dmx-server/export_tools/
 *
 * ```yaml
 * operationId: export_tools_create
 * tags:
 *   - export_tools
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/ExportTool'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ExportTool'
 *     description: ''
 * ```
 */
export const exportToolsCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: ExportToolsCreateQuery;
  request: ExportToolRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<ExportToolResponse>> => {
  const operation = exportToolsCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
